import React from 'react'
import { useSelection, useValue } from '@morningtrain/react-resources'

export default function SetSelectedItems ({ itemIdsByCategory = {} }) {
  const selection = useSelection()
  const categoryId = useValue('id')

  React.useEffect(() => {
    const ids = itemIdsByCategory && itemIdsByCategory[categoryId] ? itemIdsByCategory[categoryId] : []
    selection.clearSelected()

    if (ids.length > 0) {
      ids.forEach(id => {
        selection.toggleSingle(id, true)
      })
    }
  }, [selection, categoryId, itemIdsByCategory])

  return null
}
